export const remove_select_touch_end = (element: HTMLElement)=>{
  let list = element.parentNode?.querySelectorAll('li[id^="select-options"]')
  if (list){
    for (const el of list){
      el.addEventListener('touchend', (e)=>{
        e.stopPropagation()
      })
    }
  }
}